// extracted by mini-css-extract-plugin
export var container = "_6k-0";
export var fallback = "_6k-5";
export var fallbackIcon = "_6k-6";
export var hidden = "_6k-2";
export var image = "_6k-3";
export var loaded = "_6k-4";
export var placeholder = "_6k-1";